import React from "react";
import { Typography } from "@mui/material/";
import { strings } from "../../common/i18n";

type Props = {
    error: string,
    row: number
};

export default ({ error, row }: Props) => (
    <>
        <Typography color="error" key={row}>
            {`${strings("row")}: [${row}] ${error}`}
        </Typography>
    </>
);
